import { useState } from "react";
import { put } from "../../api/apis";
import { modalCargando } from "../../components/ui/sweetAlerts";
import { hideSideBarDesktop } from "../../utils/funciones";
import { mensajeSimple } from "../../components/ui/sweetAlerts";
import { validaGetStatus } from "../../utils/funciones";

export const useAjustesDias = () => {
  const [edit, setEdit] = useState(false);

  const enviar = async (dias) => {
    modalCargando("Guardando cambios...");
    const resp = await put('configuracion', null, { dias_anticipacion: dias });
    hideSideBarDesktop();

    if (!validaGetStatus(resp)) {
      mensajeSimple('error', "Error al guardar cambios", 2500);
      return;
    }
    mensajeSimple('success', 'Guardado Listo!', 1000);
    setEdit(false);
    
  }

  return {
    edit, setEdit, enviar
  }
}